import { v4 } from 'uuid';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const amplifyUuid = v4;

export { amplifyUuid };
//# sourceMappingURL=index.mjs.map
